import React, { useState } from "react";
import SiteWrapper from "../../SiteWrapper.react";
import {LoadingScreen} from "../../components/LoadingScreen";
import '../../pages/navBarItems/MonitoreoOTD/styles/variables.css';

import RegistroHorarios  from "../../Catalogos/RegistroHorariosMovimientos/RegistroHorarios";



const MonitoreoOTD = () => {
    
    //Variables check loading y error
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [data, setData] = useState([]);

    return (
        <>
        
        <SiteWrapper>
                <div className="movimientosVip">
                    <RegistroHorarios
                        
                    />
                  </div>
            {loading ? (
                <LoadingScreen
                    loading={loading}
                />
            ):null}
            
        </SiteWrapper>
        </>
    );
};

export default MonitoreoOTD;